import React, {Fragment} from "react";
import StepButton from "../../../../components/Step/StepButton";
import RegisterV2 from "../RegisterV2";
import StepQuestion from "../../../../components/Step/StepQuestion";
import DocumentUploadStep from "./DocumentUploadStep";
import AdditionalDocumentTypeService from "../../../../services/Limit/AdditionalDocumentTypeService";
import StepLoadingComponent from "../../../../components/Step/StepLoadingComponent";
import S3DocumentTypeEnum from "domain/S3DocumentTypeEnum";

export default class AdditionalDocumentsUploadStep extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.documentPurposeKey = this.props.documentPurposeKey || "name";
        this.documentPurposeDisplayValueKey = this.props.documentPurposeDisplayValueKey || "displayName";

        this.state = {
            loading: true,
            additionalDocuments: this.props.additionalDocuments || [],

            requiredDocumentIndex: (this.props.stepDirection === RegisterV2.BACKWARD ? (this.props.requiredDocuments.length - 1) : 0),
            isSelectingDocument: (this.props.stepDirection === RegisterV2.BACKWARD),

            documentTypeOptionsCache: []
        }
    }

    componentDidMount() {
        this.loadData();
    }

    loadData() {

        let requestArray = [];
        let documentPurposes = [];

        (this.props.requiredDocuments).forEach(document => {
            requestArray.push(AdditionalDocumentTypeService.retrieveByPurpose(document[this.documentPurposeKey]));
            documentPurposes.push(document[this.documentPurposeKey]);
        })

        Promise.all(requestArray).then(responseArray => {
            let documentTypeOptionsCache = {};
            (responseArray).forEach((documentTypeResponse, index) => {
                documentTypeOptionsCache[documentPurposes[index]] = documentTypeResponse;
            })
            this.setState({
                documentTypeOptionsCache: documentTypeOptionsCache,
                loading: false
            })
        })
    }

    onDocumentTypeSelected(documentType) {
        let additionalDocuments = {...this.state.additionalDocuments};
        let documentPurpose = this.props.requiredDocuments[this.state.requiredDocumentIndex][this.documentPurposeKey];
        additionalDocuments[documentPurpose] = {
            ...additionalDocuments[documentPurpose],
            "document-type": documentType
        };

        this.setState({
            additionalDocuments: additionalDocuments
        }, () => this.documentPurposeNextStep())
    }

    documentPurposeNextStep() {

        if (!this.state.isSelectingDocument) {
            this.setState({
                isSelectingDocument: true
            })
        } else {

            let requiredDocumentIndex = this.state.requiredDocumentIndex

            requiredDocumentIndex = requiredDocumentIndex + 1;

            let newState = {
                isSelectingDocument: false
            };

            if (requiredDocumentIndex === (this.props.requiredDocuments.length)) {
                this.setState(newState, () => this.props.onNextClick(this.state.additionalDocuments));
            } else {
                newState.requiredDocumentIndex = requiredDocumentIndex;
                this.setState(newState);
            }
        }
    }

    documentPurposeBackStep() {
        if (this.state.isSelectingDocument) {
            this.setState({
                isSelectingDocument: false
            })
        } else {
            let requiredDocumentIndex = this.state.requiredDocumentIndex;

            if (requiredDocumentIndex === 0) {
                if (this.props.onBackClick)
                    this.props.onBackClick(this.state.additionalDocuments);
            } else {
                requiredDocumentIndex = requiredDocumentIndex - 1;

                this.setState({
                    requiredDocumentIndex: requiredDocumentIndex,
                    isSelectingDocument: true
                })
            }
        }
    }

    render() {
        if (this.state.loading) {
            return <StepLoadingComponent/>
        } else {
            return <Fragment>
                {!this.state.isSelectingDocument ?
                    <Fragment>{this.renderTypeSelection()}</Fragment>
                    :
                    <Fragment>
                        {this.renderDocumentUpload()}
                    </Fragment>
                }
            </Fragment>
        }
    }

    renderTypeSelection() {

        let requiredDocument = this.props.requiredDocuments[this.state.requiredDocumentIndex];
        let documentPurpose = requiredDocument[this.documentPurposeKey];
        let displayName = requiredDocument[this.documentPurposeDisplayValueKey];

        let documentTypes = this.state.documentTypeOptionsCache[documentPurpose];

        return <Fragment>
            <StepQuestion>
                We require you to provide us with a {displayName}.
                <br/><br/>
                Please select one of the following:
            </StepQuestion>
            {Object.keys(documentTypes).map(index => {
                return <StepButton
                    key={index}
                    onClick={() => this.onDocumentTypeSelected(documentTypes[index])}>
                    {documentTypes[index].type}
                </StepButton>
            })}
            <StepButton color={"secondary"}
                        onClick={this.documentPurposeBackStep.bind(this)}>
                Back
            </StepButton>
        </Fragment>
    }

    renderDocumentUpload() {
        let documentPurpose = this.props.requiredDocuments[this.state.requiredDocumentIndex][this.documentPurposeKey];
        let additionalDocument = this.state.additionalDocuments !== undefined ? this.state.additionalDocuments[documentPurpose] : undefined;
        let selectedDocumentType = additionalDocument["document-type"];
        let customMessage = "Please upload your " + selectedDocumentType.type;

        return <DocumentUploadStep
            customMessage={customMessage}
            s3DocumentType={S3DocumentTypeEnum.REGISTRATION_DOCUMENT}
            accept={DocumentUploadStep.ACCEPT_IMAGES_PDF}
            registrationElement={"metaDataId"}
            metaDataId={additionalDocument !== undefined ? additionalDocument["additional-document-metadata-id"] : undefined}
            stepProps={this.props.stepProps}
            selectedDocument={additionalDocument !== undefined ? additionalDocument["uploaded-document"] : undefined}
            onDocumentSelected={(selectedDocument => {
                let additionalDocuments = {...this.state.additionalDocuments}
                additionalDocuments[documentPurpose] = additionalDocuments[documentPurpose] || {}

                additionalDocuments[documentPurpose] = {
                    ...additionalDocuments[documentPurpose],
                    "uploaded-document": selectedDocument
                };

                this.setState({additionalDocuments: additionalDocuments});
            })}
            onNextClick={(s3MetaDataId) => {

                let additionalDocuments = {...this.state.additionalDocuments}
                additionalDocuments[documentPurpose] = {
                    ...additionalDocuments[documentPurpose],
                    "additional-document-metadata-id": s3MetaDataId
                };
                this.setState({
                    additionalDocuments: additionalDocuments
                }, () => this.documentPurposeNextStep());
            }}
            onBackClick={this.documentPurposeBackStep.bind(this)}
        />
    }
}